<!-- =========================================================================================
    File Name: Document.vue
    Description: Document Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="Document-page" class="relative">
      <div class="page_header_wrap" :class="{ filters_open: filtersList }">
        <div class="page_header">
            <div>
              <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>Documents</h2>
            </div>
            <div class="page_actions">
              <button v-if="activeUserInfo.roleId==1" class="secondary_btn add" @click="add()">
                Add Document
              </button>
              <button  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
                <span class="material-icons"> filter_list</span>Filters
              </button>
            </div>
          </div> 
          <div class="filter_layer" @click="filtersList = !filtersList"></div>
          <div
       ref="filterCard" 
        class="user-list-filters filters_list"
        actionButtons 
          
    >
        <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Created By</label>
            <multiselect
            :multiple="true" 
            label="name"
            track-by="name"
            placeholder="Created by"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="filters.createdById" :options="customerList" >
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} Created By(s) selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              <span slot="noResult">No Users Found</span>
            </multiselect>
        </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
            <label class="text-sm opacity-75">Created Date</label>
            <date-range-picker :autoApply="autoApply" :ranges="false" :maxDate="maxDate" :opens="'right'"
            v-model="selected_createdDateRange"></date-range-picker>
          </div>

          <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Search</label>
            <input
             v-model="filters.title"
              class="search_field"
              type="text"
              @keyup.enter="onEnter"
              placeholder="Search By Title"
            />
          </div>
          
          <div class="vx-col md:w-1/4   w-full d-flex align-end justify-end marb10" >
          <button @click="clearFilters()" class="secondary_btn">
              Clear
            </button>
            <button class="primary_btn marl15" @click="get_list() , filtersList = !filtersList">
              Apply 
            </button>
          </div>
          <!-- <div
            class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex justify-end align-end"
          >
            <button class="secondary_btn add" @click="add()">
            Add Document
            </button>
          </div> -->
        </div>
      </div>
      </div> 
    
    
      
     <!-- <vs-table :data="list">
        <template slot="thead">
          <vs-th> Title </vs-th>
          <vs-th> Created on </vs-th>
          <vs-th> Action </vs-th>
        </template>-->
        <vs-table v-model="selected" noDataText="" :data="list">
        <template slot="thead">
          <vs-th> 
          <a  @click="sortMe('title')" v-bind:class="{
                    sort_ascending: sortKeys['title'] == 1,
                    sort_descending: sortKeys['title'] != 1,
                  }"
                  > Title</a>
           </vs-th>
           <!-- <vs-th><a  @click="sortMe('deviceFamName')" v-bind:class="{
                    sort_ascending: sortKeys['deviceFamName'] == 1,
                    sort_descending: sortKeys['deviceFamName'] != 1,
                  }"
                  > Device Type</a>
                  </vs-th> -->
             <!-- <vs-th>
             <a  @click="sortMe('typeName')" v-bind:class="{
                    sort_ascending: sortKeys['typeName'] == 1,
                    sort_descending: sortKeys['typeName'] != 1,
                  }"
                  >
             Type
             </a>
             </vs-th> -->
          <vs-th> 
          <a  @click="sortMe('createdOn')" v-bind:class="{
                    sort_ascending: sortKeys['createdOn'] == 1,
                    sort_descending: sortKeys['createdOn'] != 1,
                  }"
                  > Created On</a>
                 
          </vs-th>
           <vs-th class="w-80">
                Action
          </vs-th>  
        </template>
  
        <template  v-for="(Document ,index) in list" >
          <vs-tr :key="index">
            <vs-td> 
              
               {{ checkValue(Document ,'title')}}
              
              </vs-td>
             <!-- <vs-td> 
               
             {{ checkValue(Document ,'deviceFamDetails', 'name')}}
               </vs-td>
              -->
             
            
            <vs-td> {{Document.createdOn | formatDate}} 
               <br>
                <small>{{ Document.createdOn | formatTime}}</small>   
            </vs-td>
            <vs-td>
              <vs-dropdown vs-trigger-click>
                <a class="a-icon" href.prevent> 
                  <span class="material-icons">more_vert</span>
                </a>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="publishPopup( Document,true)">
                    <span v-if="checkValue(Document ,'statusDetails', '_id') ==2">Unpublish</span>
                    <span v-if="checkValue(Document ,'statusDetails', '_id') ==3 || checkValue(Document ,'statusDetails', '_id') ==1">Publish</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="activeUserInfo.roleId == 1" @click="getDetails( Document,true)"><span>Edit</span></vs-dropdown-item>
                  <template >
                  <vs-dropdown-item @click="downloadfile( Document,'download')"><span>Download Document</span></vs-dropdown-item>
                  <vs-dropdown-item @click="downloadfile( Document,'copy')"><span>Copy Document URL</span></vs-dropdown-item>
                  </template>
                  <vs-dropdown-item v-if="activeUserInfo.roleId == 1" @click="goToAnalytics(Document)" ><span>Analytics</span></vs-dropdown-item>
                  <vs-dropdown-item v-if="activeUserInfo.roleId == 1" @click="goToSentMails( Document)"><span>Sent Mails</span></vs-dropdown-item>
                  <vs-dropdown-item @click="showDetails( Document,true)"><span>View</span>
                    <!-- <router-link
                        :to="'/document-details/'+Document['_id']"
                      ><span>View</span></router-link> -->
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
        <template v-if="list.length<=0">
            <tr>
              <td colspan="5" class="center-align">No Documents Found!</td>
            </tr>
          </template>
          
      </vs-table>
      <div class="pagination_wrap" v-if="totalpages > 0">
        <div class="pagination_content">
          <h6>Show Records</h6>
          <multiselect
        :multiple="false" 
          @input="this.callFromSort  = true; change_perPage()"
        placeholder="Page"
        
        :close-on-select="true"
        :clear-on-select="false"
        :hide-selected="true"
        :preserve-search="true"
        v-model="perPage" :options="perPeges" >
          <template slot="selection" slot-scope="{ values, isOpen }">
            <span
              class="multiselect__selectcustom"
              v-if="values.length && !isOpen"
              >{{ values.length }} selected</span
            >
            <span
              class="multiselect__selectcustom"
              v-if="values.length && isOpen"
            ></span>
          </template>
          
          </multiselect>
        </div>
        <vs-pagination
        :total="totalpages"
        :max="7"
        v-model="page"
        @input="this.callFromSort  = true;get_list()"
        />
      </div>
  
  
      <vs-popup
      v-if="popupcreateticket"
        class="holamundo"
        :active.sync="popupcreateticket"
        :title="!popupeditDocument?'Add Documentation':'Edit Documentation'"
      >
        <div class="createticket_form form_section">
          <form autocomplete="off">
          
            <ul>
              <li>
                <div class="form-group">
                <label class="form_label">Title*</label>
                <vs-input
                  v-validate="'required'"
                  name="Title"
                  icon-no-border
                  icon-pack="feather" 
                  v-model="newDocument.title"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Title")
                }}</span>
                </div>
              </li>
              <li>
                <div class="form-group">
             <label class="form_label">Description*</label>
                <vs-textarea
                 v-validate="'required|min:10'"
                  v-model="newDocument.description"
                  name="Description"
                  label-placeholder="Subject"
                  
                />
                <span class="text-danger text-sm">{{
                  errors.first("Description")
                }}</span>
                </div>
              </li>
              <li>
           
           <div class="radio_wrap" >
             <vs-radio v-model="radios1" @change="onRadio" vs-name="radios1" vs-value="EveryOne">Everyone</vs-radio>
             <vs-radio v-model="radios1" @change="onRadio" vs-name="radios1" vs-value="Client">Company </vs-radio>  
             <vs-radio v-model="radios1" @change="onRadio" vs-name="radios1" vs-value="Customer">User</vs-radio>              
           </div>
            
         </li>
            <li v-if="radios1=='Client'">
           <div class="form-group">
           <label class="form_label">Company</label>
           <multiselect
             v-model="newDocument.companyIds"
             :options="companies"
             :close-on-select="false"
             :clear-on-select="false"
             :hide-selected="true"
             :preserve-search="true"
             
             :multiple="true"
             label="name"
             placeholder="Select Company"
             track-by="name"  
             id="company"
           >
             <template slot="selection" slot-scope="{ values, isOpen }">
               <span
                 class="multiselect__selectcustom"
                 v-if="values.length && !isOpen"
                 >{{ values.length }} Company(s) selected</span
               >
               <span
                 class="multiselect__selectcustom"
                 v-if="values.length && isOpen"
               ></span>
             </template>
             <span slot="noResult">No Company Found</span>

           </multiselect>
           </div>
         </li>
         <li v-if="radios1=='Customer'" > 
           <div class="taggable">
             <div class="form-group">
             <label class="form_label">Users</label>
               <multiselect 
                     v-model="newDocument.cusIds" 
                     :options="customerList" 
                     :clear-on-select="false"
                     :close-on-select="false"
                     :hide-selected="true"
                     :multiple="true"
                     :preserve-search="true"
                      @search-change="searchCustomerList"
                     placeholder="Select Users"
                     label="name"
                     track-by="name"  
                     id="customer"
                       >
                     <template slot="selection" slot-scope="{ values, isOpen }">
                       <span class="multiselect__selectcustom" 
                       v-if="values.length && !isOpen">{{ values.length }} User(s) selected</span>
                       <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                     </template>
                     <span slot="noResult">No Users Found</span>
               </multiselect>
             </div>
           </div>
         </li>
              <li>
               <div class="form-group">
               <label class="form_label">Documents*</label>
              <div class="files_wrap" @click="documents=[]">
              <file-upload v-model="documents" class="file-upload-input"
              accept="*"  :name="'documents'" data-vv-as="Upload SDK documents"
                :multiple="false" @input="upload(documents)" >
                <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
              </file-upload>
              <span class="text-danger text-sm"
                v-show="errors.has('documents')">{{ errors.first('documents') }}</span>
              </div>
              
                <ul  class="uploaded-list">                
                  <li><vs-chip @click="remove(indx)" :name="'sdkdocumentRemoveSelected'" v-for="(other, indx) in newDocument.documents" :key="indx"  closable>
                     {{ checkValue(other, 'name') }}
                      </vs-chip></li>
                </ul>
               </div>
               </li>
               <li>
               
              </li>       
             
            </ul>
          </form>
          <div class="form_actions">
            <span></span>
           
            <button
            v-if="!popupeditDocument"
            :disabled="validateMe"
              class="close_popup primary_btn"
              @click="create()"
            >
              Create
            </button>
             <button
            v-if="popupeditDocument"
            :disabled="validateMe"
              class="close_popup primary_btn"
              @click="update()"
            >
              Update
            </button>
          </div>
        </div>
      </vs-popup>
      <vs-popup
      v-if="showPublishPopup"
        class="holamundo"
        :active.sync="showPublishPopup"
        :title="showPublishPopupTitle?'Publish':'Unpublish'"
      >
        <div class="createticket_form form_section">
          <form autocomplete="off">
            <ul>
              <li>
                <div class="form-group">
                <label class="form_label">Title*</label>
                <vs-input
                  v-validate="'required'"
                  name="Title"
                  icon-no-border
                  icon-pack="feather" 
                  v-model="pubSubject"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Title")
                }}</span>
                </div>
              </li>
              <li>
                <div class="form-group">
              <label class="form_label">Description* </label>
                <ckeditor
                 v-validate="'required'"
                  name="Description"
                  :editor="editor" v-model="pubContent" :config="editorConfig"></ckeditor>
                  
                  <span class="text-danger text-sm">{{
                  errors.first("Description")
                }}</span>
              </div>
              </li>
               <li>
                <div class="form-group">
                <vs-checkbox :value="true" v-model="sendMailToAll" >Send Mail To All</vs-checkbox>
                </div>
              </li>       
             
            </ul>
          </form>
          <div class="form_actions">
            <button
              class="close_popup primary_btn"
              @click="hidePublish()"
            >
              Close
            </button>
             <button
            :disabled="validatepublish"
              class="close_popup primary_btn"
              @click="updatePublish()"
            >
            <span v-if="showPublishPopupTitle">Publish </span>
            <span v-else> Unpublish</span>
           
            </button>
          </div>
        </div>
      </vs-popup>
      <vs-popup
      v-if="showDetailsPopup"
        class="holamundo"
        :active.sync="showDetailsPopup"
        :title="'Document Details'"
      >
      <div class="knowledge_base_wrap">
         

           
         <div class="knowledge_base_cnt knowledge_base_details">
           <div class="knowledge_base_list">
            <ul>
              <li v-if="checkValue(documentDetails  , 'title' )">
                  <label>Title</label> <p> 
                     {{checkValue(documentDetails  , 'title' )}}
                    </p>
                </li>
                <li v-if="checkValue(documentDetails  , 'description' )">
                    <label>Description</label> <p>
                       {{checkValue(documentDetails  , 'description' )}}
                       </p>
                </li>
                <li>
                <label>Documents</label> 
                <p v-if="documentDetails.documents && documentDetails.documents.length > 0">
                   {{documentDetails.documents[0].name}}
                   <span @click="download_file(documentDetails.documents[0])" class="material-icons download">get_app</span>
                   </p>
                    
                </li>
             
            </ul>
           </div>
         </div>
        </div>
      </vs-popup>
  
      
    </div>
  </template>
  
  <script>
  import vSelect from 'vue-select'
  import DateRangePicker from "vue2-daterange-picker";
  import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
  import Multiselect from "vue-multiselect-inv";
  import moment from "moment";
  import _ from "lodash";
  import FileUpload from "vue-upload-component/src";
  import CKEditor from '@ckeditor/ckeditor5-vue2';
  Vue.use( CKEditor );
  import Vue from 'vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  export default {
    components: {
      vSelect,
      DateRangePicker,
      Multiselect,
      FileUpload
    },
    computed: {
      activeUserInfo () {
        console.log(JSON.stringify(this.$store.state.auth.user));
        return this.$store.state.auth.user
      },
      validateMe () {
        if( this.errors.any()
        || (  this.newDocument.title ==null || this.newDocument.title =='' || this.newDocument.title.trim() ==''   )
        || (  this.newDocument.description ==null || this.newDocument.description =='' || this.newDocument.description.trim() ==''   )
        || (this.newDocument.documents.length<=0)
        ){
          let l = "title "+this.newDocument.title +" \n --"
                  +"description "+this.newDocument.description +" \n -- "
          return true;
        }else{
          return false;
        }
      },
      validatepublish () {
        if( this.errors.any()
        || (  this.pubContent ==null || this.pubContent =='' || this.pubContent.trim() ==''   )
        || (  this.pubSubject ==null || this.pubSubject =='' || this.pubSubject.trim() ==''   )
        ){
          return true;
        }else{
          return false;
        }
      }
    },
    data () {    
      return {
        radios1: 'EveryOne',
        searchCustomer:'',
        companies: [],
        customerIds: [],
        companyIds: [],
        cusIds: [],
        showDetailsPopup:false,
        documentDetails:'',
        selectedDocs:'',
        sendMailToAll:true,
        editor: ClassicEditor,
        editorConfig: {
          toolbar: [ 'bold', 'italic', '|', 'undo','redo' ,"indent" ,"Outdent" ,'NumberedList', 'BulletedList', ],          
        },
        pubContent:'',
        pubSubject:'',
        customerList:[],
        callFromSort:false,
        filtersList: false,
        documents:[],
        disabledBtn:false,
        deviceFamily:[],
        Areas:[],
        selectoptions: ['list', 'of', 'options'],
        newDocument:{
            title: "",
            description: "",
            documents:[],
            cusIds:[],
            companyIds:[]
        },
        description:'',
        statusOptions:[],
        statusFilter:null,
        Title:'',
        popupeditDocument:false,
        showPublishPopup:false,
        showPublishPopupTitle:false,
        popupcreateticket:false,
        textarea:'',
  
        selected:'',
        sortKeys: {
          name: 1,
          statusName: 1,
          createdOn: -1,
          email: 1,
          roleName: 1
        },
        list: [],
        sortKey: {},
        email: '',
        users: '',
        page: 1,
        perPage: 25,
        totalpages: 0, 
        perPeges: [25, 50, 75, 100],
        filters:{
            "title": "",
            createdById:[],
        },
        maxDate: new Date(),
        selected_createdDateRange :{
            startDate: null,
            endDate: null
        },
        autoApply: "",
      }
    },
    methods: {
      onRadio() {
       
      this.newDocument.cusIds = []
      this.newDocument.companyIds = []
    },
      goToAnalytics(item){
        this.$router.push('/docanalytics/'+item['_id']);
      },
      goToSentMails(item){
        let routeId =  this.checkValue(item,'_id')
        this.$router.push('/sent-emails/'+routeId+'/'+false);
        // this.$router.push({ 
        //   name: 'page-group-base-emails', params: { 'filter':routeId,'sdk':false}
          
        // })
    },
      showDetails(item){
        let selectedDocs = item 
        let payload = {
           documentId: '',
        };
        if(this.checkValue(selectedDocs,'_id')){
          payload['documentId'] = this.checkValue(selectedDocs,'_id')
        }
        
      let path ="/document/details";
      
      this.$store.dispatch("commonAction", { "data": payload,"path":path}).then((res) => {
      
          this.documentDetails = res;
          this.showDetailsPopup = true
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
      },
      updatePublish(){
        let postData = {
          documentId:this.checkValue(this.selectedDocs,'_id'),
          pubSubject:this.pubSubject,
          pubContent:this.pubContent,
          sendMailToAll:this.sendMailToAll,
          //unPublishFlag:true
        } 
        if(this.checkValue(this.selectedDocs,'statusDetails', '_id') == 1 || this.checkValue(this.selectedDocs,'statusDetails', '_id') == 3 ){
          postData['unPublishFlag'] = false
        }
        if(this.checkValue(this.selectedDocs,'statusDetails', '_id') == 2 ){
          postData['unPublishFlag'] = true
        }
        let path ="/document/publish";
        this.$vs.loading();
        this.$store.dispatch("commonAction", { "data": postData,"path":path}).then((response) => {
       
          this.showPublishPopup  = false
             this.$vs.loading.close();
             this.get_list();
            this.$vs.notify({
              title: "Success",
              text: response.message,
              position: "top-right",
              iconPack: "feather",
              position: "top-right",
              icon: "icon-alert-circle",
              color: "success",
            });
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.error_message.message,
              iconPack: "feather",
              position: "top-right",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });

      },
      hidePublish(){ 
        this.showPublishPopup = false
        this.pubContent = '';
        this.pubSubject = '';
      },
      publishPopup(item,action){
        let docDetails = item
        this.selectedDocs = item
        this.pubContent = '';
        this.pubSubject = '';
        this.showPublishPopupTitle = false
        if(this.checkValue(docDetails,'statusDetails','_id') == 1 || this.checkValue(docDetails,'statusDetails','_id') == 3){
          this.showPublishPopupTitle = true
        }
        this.sendMailToAll = true
        this.showPublishPopup = action
        let payload = {
        documentId: this.checkValue(this.selectedDocs,'_id'),
      };
      let path ="/document/get-publish-email-content";
      
      this.$store.dispatch("commonAction", { "data": payload,"path":path}).then((res) => {
      
        if(res){
          
          this.pubContent =res['body'];
          this.pubSubject =res["subject"];
        }
        })
        .catch((error) => {
          console.log(err);
        });
      },
       checkValue(object =null ,mainKey='' ,subKey =''){
           if(object != null && mainKey !='' ){
               if(_.has(object ,mainKey)){
   
                   if(subKey !=''){
                       if( _.has(object[mainKey] ,subKey )){
                           return object[mainKey][subKey];
   
                       }else{
                           return '';
   
                       }
   
                   }else{
                       return object[mainKey];
   
                   }
   
               }else{
                   return '';
               }
   
           }else{
               return '';
           }
   
      
  
      },
      onEnter() {
        this.filtersList =false;
        this.get_list();
      },
      check(e){
       if (e.target.checked) {
         this.newDocument.wrkAround ="yess";
  
       }else{
         this.newDocument.wrkAround ="";
       }
       
      },
      download_file(value) {
      if(_.has(value , "path")){
        value['url'] = value['path'];
      }

      let postdata = { keyName: value.url };

      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        
          window.open(response.data.result.data, "_blank");
       
      });
    },
    downloadfile(item , category) {
      let selectedDocs = item
     
      let selectedCategory = category
      let postData={
        keyName:''
      }
      if(this.checkValue(selectedDocs['documents'][0],'path')){
        postData['keyName'] = this.checkValue(selectedDocs['documents'][0],'path')

      }
      this.$store.dispatch("getSignedUrl", postData).then((response) => {
        if(selectedCategory == 'download'){
          this.download_clicks(selectedDocs, selectedCategory)
          window.open(response.data.result.data, "_blank");
        }
        if(selectedCategory == 'copy'){
          setTimeout(()=>{  
            try {
              if(selectedCategory == 'copy'){
                navigator.clipboard.writeText(response.data.result.data);
                this.download_clicks(selectedDocs, selectedCategory) 
              }
                    
            } catch ($e) {
              console.log($e)
            }
          } ,100);
        }
      });
    },
    download_clicks(item, category){
      let docsDetails = item
      let payload = {
        action: category,
        documentId: '',
      };
      if(this.checkValue(docsDetails,'_id')){
        payload['documentId'] = this.checkValue(docsDetails,'_id')
      }
      let path ="/document/track-clicks";
      this.$store.dispatch("commonAction", { "data": payload,"path":path}).then((response) => {
        if(category == 'copy'){
          this.$vs.notify({
                        text: 'URL was copied successfully' ,
                        title: "Success",
                        position:'top-right',
                        color:"success",
                        iconPack: 'feather',
                        icon:'icon-check',

                      });
        }
        console.log(response)
      }).catch((err)=>{
        console,log(err)
      })
    },
   
      getDeviceFamily(){
        let postData ={
          page: 1,
          perpage: 10000000,
          category: 'device_family'
        }
        this.$store.dispatch("getDeviceFamily" ,postData).then((response) => {
        this.deviceFamily = response;
       
      });
  
      },
      
      getAreas(){
        let postData ={
          page: 1,
          perpage: 10000000,
          category: 'area'
        }
        this.$store.dispatch("getAreas" ,postData).then((response) => {
        this.Areas = response;
       
      });
  
      },
      create(){
        let postData = this.newDocument
        if (postData.companyIds && postData.companyIds.length > 0) {
          postData.companyIds = postData.companyIds.map(item => item._id)
        }
        if (postData.cusIds && postData.cusIds.length > 0) {
          postData.cusIds = postData.cusIds.map(item => item._id)  
        }
        let path ="/document/create";
        this.$vs.loading()
        this.$store.dispatch("commonAction", { "data": postData,"path":path}).then((response) => {
           this.popupcreateticket = false
             this.$vs.loading.close();
             this.get_list();
            this.$vs.notify({
              title: "Success",
              text: response.message,
              position: "top-right",
              iconPack: "feather",
              position: "top-right",
              icon: "icon-alert-circle",
              color: "success",
            });
          })
          .catch((err) => {            
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.error_message.message,
              iconPack: "feather",
              position: "top-right",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
  
      },
      update(){
        let postData = this.newDocument
        if(this.checkValue(this.selectedDocs,'_id')){
          postData['documentId'] = this.checkValue(this.selectedDocs,'_id')
        }
        if (postData.companyIds && postData.companyIds.length > 0) {
          postData.companyIds = postData.companyIds.map(item => item._id)
        }
        if (postData.cusIds && postData.cusIds.length > 0) {
          postData.cusIds = postData.cusIds.map(item => item._id)  
        }
        let path ="/document/update";
        this.$vs.loading();
        //this.newDocument['documentId'] =this.newDocument['_id'];
        this.$store.dispatch("commonAction", { "data": postData,"path":path}).then((response) => {
       
          this.popupcreateticket = false
             this.$vs.loading.close();
             this.get_list();
            this.$vs.notify({
              title: "Success",
              text: response.message,
              position: "top-right",
              iconPack: "feather",
              position: "top-right",
              icon: "icon-alert-circle",
              color: "success",
            });
          })
          .catch((err) => {
            //console.log(err);
             
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.error_message.message,
              iconPack: "feather",
              position: "top-right",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
  
      },
      getDetails(item,callFroEdit=false) {
        let payload = {
            documentId:item._id,
        };
        this.selectedDocs = item
        let path ="/document/details";
        this.$store.dispatch("commonAction", { "data": payload,"path":path}).then((res) => {
          let response = res
          if(this.checkValue(response,'title')){
            this.newDocument.title = this.checkValue(response,'title')
          }
          if(this.checkValue(response,'description')){
            this.newDocument.description = this.checkValue(response,'description')
          }
          if(this.checkValue(response,'documents')){
            this.newDocument.documents = this.checkValue(response,'documents')
          }
          this.newDocument.cusIds = []
          this.newDocument.companyIds = []
            
            if(_.has(response, 'cusIds') && response.cusIds.length>0){
              //this.newDocument.cusIds = []
              this.radios1 = 'Customer';
              _.forEach(response['cusIds'],(item)=>{
                let _id = item
                let obj = _.find(this.customerList ,{"id":_id} );
                this.newDocument.cusIds.push(obj)
              })
            }
            else if(_.has(response, 'companyIds') && response.companyIds.length>0){
              //this.newDocument.companyIds = []
              this.radios1 = 'Client';
              _.forEach(response['companyIds'],(item)=>{
                let _id = item
                let obj = _.find(this.companies ,{"id":_id} );
                this.newDocument.companyIds.push(obj)
              })
            }
            else{
              this.radios1 = 'EveryOne';
            }
            setTimeout(()=>{
              if(callFroEdit){
                this.edit();
              }
            })
            
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: error.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
      },
        add(){
        this.newDocument={
            title: "",
            description: "",
            documents:[],
            cusIds:[],
            companyIds:[]
        },
        this.radios1 = 'EveryOne',
          this.popupcreateticket = true;
          this.popupeditDocument =false;
        },
        edit(){
           this.popupcreateticket = true;
           this.popupeditDocument =true;
        },
  
      get_list () {
        let postData = {
          filters:{"title": this.filters.title,"createdOnRange":[],createdBy:[]},
          sorting: this.sortKey, 
          page: this.page,
          perpage: this.perPage,
        }
        if(_.has(this.selected_createdDateRange ,'startDate' )  && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
          postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
          postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
        }
        if(this.filters.createdById && this.filters.createdById.length > 0){
            for( let i=0; i<this.filters.createdById.length;i++){
                postData.filters.createdBy.push(this.filters.createdById[i]['_id'] )
            }
        }
        
         if(!this.callFromSort){
            this.list = []
        }
         this.callFromSort  = false;
       this.$vs.loading()
       let path ="/document/list";
       this.$store.dispatch("commonAction", { "data": postData,"path":path}).then((response) => {
             this.$vs.loading.close();
             this.list = response.list
             this.totalpages = Math.ceil(response.totalCount / this.perPage)
          })
          .catch((err) => {
             this.$vs.loading.close();
            //console.log(err)
          })
      },
      change_perPage() {
          this.page = 1;
  
          this.get_list();
        },
      sortMe(sort_key = "") {
    
      this.sortKey = { path: "createdOn", order: 1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};
  
        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort  = true;
  
        this.get_list();
      }
    }, 
     upload(model){
  
        
  
            let temp_count = 0;
            let formData = new FormData();
            this.disabled_btn = true;          
            let mapper = model.map(
                item =>
                (item = {
                    name: item.name,
                    file: item.file ? item.file : null,
                    path: item.url ? item.url : "",
                    extn: item.name.split('.').pop(),
                    mimetype: item.type ? item.type : item.mimetype,
                    
                })
            );
            
            
                this.$vs.loading();
                if (mapper.length > 0) {
                mapper.forEach((doc, index) => {
                    formData.append("files", doc.file);
                    formData.append("secureType", "private");
                    this.$store.dispatch("uploadS3File", formData).then(response => {
                        temp_count++;
                        response.data.result.forEach(urlGenerated => {
  
                            
                              this.newDocument.documents.push(urlGenerated);
                            
                            if (temp_count >= mapper.length) {
                                this.disabled_btn = false;
                                this.$vs.loading.close();
                            }
  
                            doc.url = urlGenerated;
                            delete doc.file;
                            mapper[index] = doc;
  
                        });
                    });
  
                });
                model.splice(0, mapper.length, ...mapper);
            }
              
  
            
             
  
            
        }, 
  
      remove(index){
        this.newDocument.documents.splice(index , 1);
      },
      clearFilters() {
        this.filtersList =false;
        this.filters = {
          "title": '',	
          "createdOnRange":[]
        },
        this.selected_createdDateRange  = {
          startDate: null,
          endDate: null
        },
        this.get_list();
      },
      searchCustomerList(val=''){
       this.sdkUsers =[];
      this.searchCustomer = val;
      this.getCustomerList();
    }, 
      getCustomerList() {
      let postData = {"filters":{"title":this.searchCustomer,"roleIds":[2],"statusIds":[],"createdOnRange":[] ,"companyIds":[]},"sorting":{"path":"createdOn","order":1},"page":1,"perpage":25};
      this.customerList = [];
      let path = '/users/list'
      this.$store.dispatch("commonAction", { "data": postData,"path":path}).then((response) => {
    
          let dt  = response.list;
          if(dt.length>0){
            _.forEach(dt ,(obj)=>{
              obj =Object.assign(obj,{ 'id':obj['_id']});
              let cus = obj;
              if(_.has(obj ,"companyDetails")){
                cus['name'] =  cus['name']+" ("+obj['companyDetails']['name']+")"
              }
              this.customerList.push(cus);



            });

          }
          //this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
          this.loaded = true;
        });
        },
        getCompanies(){
          this.$store.dispatch("getCompanies").then((response) => {
          this.companies = response;
          _.forEach( this.companies,(item) => {
            item =Object.assign(item,{ 'id':item['_id']});
          })
        });
        }
    },
    
    mounted () {
        // this.getDeviceFamily();
        // this.getAreas();
        this.get_list();
        this.getCustomerList();
        this.getCompanies();
    },
    watch:{
     
      popupcreateticket:(val)=>{
          let el = document.body;
          if (val) {
              el.classList.add('body-hidden');
          } else {
              el.classList.remove('body-hidden');
          }
          
      },
      
      
    }
  }
  </script>
  
  <style lang="scss">
 
  .not-data-table {
    display: none;
  }
  </style>
  